import { render, staticRenderFns } from "./SourceDetailsModal.vue?vue&type=template&id=1b6c7d43&"
import script from "./SourceDetailsModal.vue?vue&type=script&lang=ts&"
export * from "./SourceDetailsModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports